import React from "react";
import "./aristi.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import FeaturesOnServices from "./FeaturesOnServices";
import OurApproach from "./OurApproach";
import Technologies from "./Technologies";
import CallToAction from "./CallToAction";

const Aristi = () => {
  return (
    <>
      <Particles title="Aristi" />
      <HeroSection />
      <FeaturesOnServices />
      <OurApproach />
      <Technologies />
      <CallToAction />
    </>
  );
};

export default Aristi;
